var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
/**
 * Which address the field holds, as seen by the viewer. The frontend's words for
 * it (label, hint, what a change does) follow from this alone.
 *
 * - CONTACT: a patient without a login — the office's Contact address (#1849).
 * - INVITE: the address an open invite went to (#1827).
 * - LOGIN: somebody else's Login address.
 * - OWN_LOGIN: the viewer's own Login address.
 */
export var AddressFieldKind;
(function (AddressFieldKind) {
    AddressFieldKind["CONTACT"] = "CONTACT";
    AddressFieldKind["INVITE"] = "INVITE";
    AddressFieldKind["LOGIN"] = "LOGIN";
    AddressFieldKind["OWN_LOGIN"] = "OWN_LOGIN";
})(AddressFieldKind || (AddressFieldKind = {}));
/**
 * How the viewer may change the address.
 *
 * - INLINE: saved on blur like the fields around it; no mail goes out.
 * - STEP: a change sends mail, so it is an explicit step that says so first.
 * - NONE: read-only for this viewer.
 */
export var AddressFieldEdit;
(function (AddressFieldEdit) {
    AddressFieldEdit["INLINE"] = "INLINE";
    AddressFieldEdit["STEP"] = "STEP";
    AddressFieldEdit["NONE"] = "NONE";
})(AddressFieldEdit || (AddressFieldEdit = {}));
/** What the viewer may do about the Person's login, beside the address. */
export var AccessAction;
(function (AccessAction) {
    AccessAction["INVITE"] = "INVITE";
    AccessAction["RESEND_INVITE"] = "RESEND_INVITE";
    AccessAction["WITHDRAW_INVITE"] = "WITHDRAW_INVITE";
    AccessAction["UNLINK"] = "UNLINK";
})(AccessAction || (AccessAction = {}));
export class AccessActionDto {
    action;
    /** Shown but not runnable — today only an invite without an address to go to. */
    available;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], AccessActionDto.prototype, "action", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], AccessActionDto.prototype, "available", void 0);
/**
 * The email field as the backend sees it for this viewer: the frontend renders it
 * and decides nothing itself. The rules are the ones the endpoints enforce — see
 * `describeAddressField` in identity's domain.
 */
export class AddressFieldDto {
    /** The address the field shows: the Contact address, the invite's, or the login. */
    value;
    kind;
    edit;
    /**
     * The change needs the viewer's password from within the re-auth window. Whether
     * the session is still that fresh is the client's to check against `auth_time`.
     */
    reauthRequired;
    actions;
}
__decorate([
    Expose(),
    __metadata("design:type", Object)
], AddressFieldDto.prototype, "value", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], AddressFieldDto.prototype, "kind", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], AddressFieldDto.prototype, "edit", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], AddressFieldDto.prototype, "reauthRequired", void 0);
__decorate([
    Expose(),
    Type(() => AccessActionDto),
    __metadata("design:type", Array)
], AddressFieldDto.prototype, "actions", void 0);
//# sourceMappingURL=address-field.js.map